/**
 * Business model strategy module index
 * 
 * This file exports all the components and functions from the business model strategy modules.
 */

import { createBusinessModelStrategy } from './strategy';
import { BusinessModelOptions } from './components';
import { COMPANY_STAGES, COMPANY_STAGE_CATEGORIES } from './constants';
import { generateBusinessModelData } from './utils';

// Create and export the business model strategy
const businessModelStrategy = createBusinessModelStrategy();

// Export the components and utility functions
export { 
  BusinessModelOptions,
  COMPANY_STAGES,
  COMPANY_STAGE_CATEGORIES,
  generateBusinessModelData
};

// Export the strategy as default
export default businessModelStrategy;
